import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-block-progress-bar',
  templateUrl: './block-progress-bar.component.html',
  styleUrls: ['./block-progress-bar.component.scss']
})
export class BlockProgressBarComponent implements OnInit {
  @Input() completedQValue: number;
  @Input() selectedValue: number;
  @Input() maxValue: number;
  @Input() showLabel: boolean = true;
  @Input() blockCount: number = 10;

  constructor() { }

  ngOnInit(): void {
    // Ensure values are within valid range
    if (this.completedQValue < 0) {
      this.completedQValue = 0;
    }
    if (this.completedQValue > this.maxValue) {
      this.completedQValue = this.maxValue;
    }
    if (this.selectedValue < 0) {
      this.selectedValue = 0;
    }
  }

  get progressPercentage(): number {
    return Math.min(100, Math.max(0, (this.completedQValue / this.maxValue) * 100));
  }

  get filledBlocks(): number {
    return Math.min(this.completedQValue, this.maxValue);
  }

  get blocks(): Array<{ filled: boolean, index: number, isCompletedBlock: boolean, isSelectedBlock: boolean }> {
    const blocks = [];
    for (let i = 0; i < this.blockCount; i++) {
      const effectiveSelectedBlock = Math.min(this.selectedValue - 1, this.blockCount - 1);
      const isSelected = i === effectiveSelectedBlock && this.selectedValue > 0;
      
      blocks.push({
        filled: i < this.filledBlocks,
        index: i,
        isCompletedBlock: i === this.completedQValue - 1 && this.completedQValue > 0,
        isSelectedBlock: isSelected
      });
      
    }
    return blocks;
  }

  trackByIndex(index: number, item: any): number {
    return item.index;
  }
}
